import { IconButton, useTheme } from '@mui/material';
import { ReactComponent as CheckedIcon } from '../assets/icons/24/checkbox_checked.svg';
import { ReactComponent as UncheckedIcon } from '../assets/icons/24/checkbox_unchecked.svg';
import SvgIcon from './SvgIcon';
import { getThemeColors } from '../helpers/themeStyles';

const Checkbox = ({ checked, onChange }) => {
  const theme = useTheme();
  const colors = getThemeColors(theme);

  return (
    <IconButton disableRipple={true} onClick={onChange} sx={{ padding: 0 }}>
      {checked ? <SvgIcon icon={CheckedIcon} color={colors.checkboxChecked} /> : <UncheckedIcon />}
    </IconButton>
  );
};

export default Checkbox;
